import styled, { css } from 'styled-components'
import { ResponsiveImage } from '../ResponsiveImage/ResponsiveImage'
import { ThumbSlider } from './ThumbSlider/ThumbSlider'

export const FullWidthImage = styled(ResponsiveImage)<{ aspectRatio?: string }>`
  width: 100%;
  ${({ aspectRatio }) => {
    return (
      aspectRatio &&
      css`
        aspect-ratio: ${aspectRatio};
      `
    )
  }}
`

export const StyledThumbSlider = styled(ThumbSlider)`
  ${(props) => {
    return props.hasBullets
      ? css`
          padding: 1.2rem 3.5rem 0.4rem 3.5rem !important;

          .swiper-wrapper {
            width: auto;
          }

          .swiper-slide {
            max-width: 3rem;
          }

          @media screen and (min-width: 768px) {
            .swiper-slide {
              max-width: 4rem;
            }
          }
        `
      : css`
          margin-top: 2rem;
        `
  }}

  ${(props) => {
    return (
      props.hasBullets &&
      props.bulletsType === 'squared' &&
      props.bulletsPosition === 'bottom' &&
      css`
        &.swiper {
          padding: 2rem 1rem;
          background: linear-gradient(
            0deg,
            rgba(0, 0, 0, 0.1) 0%,
            rgba(255, 255, 255, 0) 100%
          );
        }
      `
    )
  }}

${(props) => {
    return (
      props.hasBullets &&
      props.bulletsType === 'squared' &&
      props.bulletsPosition === 'top' &&
      css`
        &.swiper {
          padding: 2rem 1rem;
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0.1) 0%,
            rgba(255, 255, 255, 0) 100%
          );
        }
      `
    )
  }}

${(props) => {
    return (
      props.hasBullets &&
      props.bulletsType === 'rounded' &&
      css`
        margin-top: 2rem;
        margin-bottom: 2rem;

        .swiper-slide {
          width: auto !important;
        }
      `
    )
  }}

  .swiper-wrapper {
    justify-content: center;
  }

  @media screen and (max-width: 767px) {
    padding-top: 2rem;
  }
`

export const Container = styled.div<{ hasZoom?: boolean }>`
  width: 100%;
  position: relative;

  .swiper-slide {
    align-self: center;
  }

  .slide--stretch {
    align-self: stretch;
    height: auto;
    align-items: center;
    background: ${({ theme }) => theme.colors.carouselBackground};
    display: flex;
    ${(props) => {
      return (
        props.hasZoom &&
        css`
          cursor: zoom-in;
        `
      )
    }};
  }

  * {
    user-select: none;
  }

  @media screen and (max-width: 767px) {
    width: 100%;
  }
`

const ArrowContainer = styled.div`
  user-select: none;
  position: fixed;
  top: 50%;
  transform: translate(0, -50%);
  z-index: 20000;
`

export const LeftArrowContainer = styled(ArrowContainer)`
  left: 0;
`

export const RightArrowContainer = styled(ArrowContainer)`
  right: 0;
`

export const Video = styled.video`
  width: 100vw;
  height: auto;
`
